<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0"
    >
      <loading-screen/>
    </v-row>
  </v-container>
</template>

<script>
  import {getAllScopes} from "../api/api-auth"
  import LoadingScreen from "../components/Helpers/LoadingScreen"

  export default {
    name: "RedirectLogin",
    components: {LoadingScreen},
    created() {
      const loginHint = this.$route.query["login_hint"] || ""
      const redirectAfterLogin = this.$route.query["redirect"] || ""
      const firstLogin = this.$route.query["fl"] ? "1" : "0"

      // Redirect after login route
      window.localStorage.setItem("ral", redirectAfterLogin)

      // First login flag
      window.localStorage.setItem("fl", firstLogin)

      this.$apiAuth.oauthAuthorizationCode(getAllScopes(), "login", loginHint)
    },
  }
</script>

<style scoped lang="scss">
</style>
